import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService
} from 'app/services';
import {
  alerts,
  confirmDialog,
  actionIcon
} from 'app/components/global';
import processes from '../processes';
import editDepartmentDialog from '../dialog.editDepartmentDialog';
import editProcessDialog from '../processes/dialog.editProcessDialog';
import controller from './department.controller';
import directive from './department.directive';


export default angular.module('app.components.advisory.enterpriseModeling.department', [
  ssDialogService,
  alerts,
  actionIcon,
  processes,
  loaderService,
  emDataService,
  confirmDialog,
  editDepartmentDialog,
  editProcessDialog
])
  .directive('emDepartment', directive)
  .controller('DepartmentController', controller)
  .name;

console.log('app.components.advisory.enterpriseModeling.department created');
